
export const defaultConfiguration = {
    titleClosed: 'Chat starten!',
    titleOpen: 'Los chatten!',
    closedStyle: 'Chat', // button or chat
    closedChatAvatarUrl: '', // only used if closedStyle is set to 'chat'
    cookieExpiration: 1, // in days. Once opened, closed chat title will be shown as button (when closedStyle is set to 'chat')
    introMessage: 'Wie kann ich Ihnen behilflich sein?',
    autoResponse: 'Danke, ich suche nach verfügbaren Mitarbeitern (es kann etwas dauern). Gern beantworte ich alle Fragen auch telefonisch: +49 34244 5946-0',
    autoNoResponse: 'Leider ist aktuell niemand verfügbar, versuchen Sie uns telefonisch innerhalb der Betriebszeiten zu erreichen: +49 34244 5946-0',
    placeholderText: 'Nachricht senden',
    displayMessageTime: true,
    mainColor: '#1f8ceb',
    alwaysUseFloatingButton: false,
    desktopHeight: 450,
    desktopWidth: 380
};
